<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { cloneDeep } from 'lodash';
import { MeRef } from '@/plugins/interfaces/Me';
import useAuthStore from '@/stores/authentication/auth';
import Conversation from '@/stores/communication/Conversation';

const userAuth = useAuthStore();

const me = ref(cloneDeep(MeRef));

onMounted(() => {
	userAuth
		.authMe()
		.then((response) => {
			if (response.status === 200) me.value = userAuth.getMe;
		})
		.catch((error) => {
			console.log(error);
		});
});

defineProps<{
	conversations?: Conversation[];
	loading?: boolean;
}>();

function lastMessagePreview(c: Conversation) {
	let m = c.latest_message;
	let sender = '';

	if (!m) return '';
	else {
		if (m.sender.id == me.value.me.id) sender = 'You: ';
		else if (m.sender.profile && c.type === 'group') {
			sender = `${m.sender.profile.first_name} ${m.sender.profile.last_name}: `;
		}
	}
	return (
		sender +
		(m.message && m.message.length > 60
			? m.message.slice(0, 60) + '…'
			: m.message)
	);
}

function lastMessageSender(m: Conversation) {
	// const m = c.last_message && c.last_message[0];
	return m && m.latest_message.sender
		? `${m.latest_message.sender.profile?.first_name || ''} ${
				m.latest_message.sender.profile?.last_name || ''
		  }`.trim() || m.latest_message.sender.email
		: m.display_name || 'Conversation';
}
</script>

<template>
	<v-list two-line selectable>
		<v-skeleton-loader
			v-if="loading"
			type="list-item-avatar-two-line"
			:loading="loading"
		/>
		<template v-else>
			<v-list-item
				v-for="c in conversations"
				:key="c.uuid"
				@click="$emit('open', c.uuid, c.display_name)"
				class="cursor-pointer"
			>
				<v-icon v-if="c.type === 'group'" color="teal"
					>mdi-account-group</v-icon
				>
				<v-icon v-else color="teal">mdi-account-circle</v-icon>

				<v-list-item-title>{{
					c.display_name || lastMessageSender(c)
				}}</v-list-item-title>
				<v-list-item-subtitle class="text-truncate">
					{{ lastMessagePreview(c) }}
				</v-list-item-subtitle>

				<v-list-item-action>
					<v-badge
						v-if="c.unread_count"
						:content="c.unread_count"
						color="red"
					/>
				</v-list-item-action>
			</v-list-item>
		</template>
	</v-list>
</template>
